/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext, useState } from 'react';
import { useTranslation } from '@scuf/localization';
import { Button } from '@scuf/common';
import descriptors from '../../../../locales/en-US/descriptors';
import { ApiContext } from '../../../../context/ApiContext';
import { EnergyUsageField } from '../../../shared/Enums';
import { IEmaasEnergyUsageComponentData } from '../../IEnergyManagementProps';
import { basicGraphEnergy, getSpanDetails } from '../../../shared/Utils/Utils';
import ChartWidget from '../../../shared/Chart/ChartWidget';
import { getDateLabel } from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { IGrapghData } from '../../../shared/Chart/IChartWidgetProps';
interface IEmaasBasicSubEnergyUsageGraphComponentProps {
  data: IEmaasEnergyUsageComponentData;
  viewType?: string;
}

export const EmaasBasicSubEnergyUsageGraphComponent = (
  props: IEmaasBasicSubEnergyUsageGraphComponentProps
) => {
  const [t, lng] = useTranslation();
  const d = descriptors.energyManagement;
  const { data, viewType } = props;
  const apiContext = useContext(ApiContext);
  const {
    redirect,
    onEnergyUsageViewDetailsClick,
    userPreferedUnit
  } = apiContext;
  const {
    aggregationsStartDate,
    aggregationsEndDate,
    performanceAggregationApplied,
    monthWiseAggregations,
    energyMeasurementUnit,
    rootNodeId
  } = data;

  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;

  const onViewDetailsClick = () => {
    if (
      viewType === EnergyUsageField.SITEENERGY &&
      onEnergyUsageViewDetailsClick
    ) {
      onEnergyUsageViewDetailsClick();
    }
    if (redirect) {
      redirect(`/energyViewDetails/root/${rootNodeId}/portfolio-view`);
    }
  };

  const {
    startMonth,
    startYear,
    endMonth,
    endYear,
    startDate,
    endDate
  } = getSpanDetails(aggregationsStartDate, aggregationsEndDate);

  const graphData = basicGraphEnergy(
    monthWiseAggregations,
    fromUnit,
    energyMeasurementUnit,
    undefined,
    lng
  );

  return (
    <div className="kpi-card-flex-container">
      <div className="kpi-card-monthwise-container">
        <div className="kpi-card-monthwise-date-range energyGraph">
          {t(d.ENERGYUSAGEDETAILS)}{' '}
          {getDateLabel(
            startMonth,
            endMonth,
            performanceAggregationApplied,
            startYear,
            endYear,
            startDate,
            endDate
          )}
        </div>
        <ChartWidget
          graphData={graphData as IGrapghData}
          unit={graphData.chartUnit}
          axisUnitType="consumption"
          height="150px"
          legendBaseline={true}
        />
        <div className="kpi-card-view-details New-siteDashboard">
          <Button
            type="link"
            content={t(d.VIEWDETAILS)}
            className="view-details-button"
            onClick={() => onViewDetailsClick()}
          />
        </div>
      </div>
    </div>
  );
};
export default memo(EmaasBasicSubEnergyUsageGraphComponent);
